module.exports = __webpack_public_path__ + "img/icon-eye-alt.35fd2519.svg";